export function exportCsv(rows, header, mapFn, filename) {
  if (!rows.length) return;
  const csv = rows.map(mapFn).join('\n');
  const blob = new Blob([header + csv], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
